const en = Object.freeze({
  hello: 'Hello',
  home: 'Home',
  receiptPosting: 'Receipt posting',
  products: 'Products',
  addProduct: 'Add product',
  addNewProduct: 'Add new product',
  auctions: 'Auctions',
  welcome: 'Welcome',
  reception: 'Reception',
  addReception: 'Add reception',
  addClient: 'Add Client',
  seller: 'Seller',
  dateOfDropOff: 'Date of drop off',
  estimatedWorth: 'Estimated worth',
  associatedWith: 'Associated with',
  changelog: 'Changelog',
  save: 'Save',
  goBack: 'Go Back',
  UseOldProduct: 'Use old product',
  comment: 'Comment',
  description: 'Description',
  english: 'English',
  finnish: 'Finnish',
  swedish: 'Swedish',
  finland: 'Finland',
  europe: 'Europe',
  otherCountries: 'Other countries',
  addToAuction: 'Add to auction',
  technicalInformation: 'Technical information',
  material: 'Material',
  fitnessRating: 'Fitness rating',
  reference: 'Reference',
  year: 'Year',
  country: 'Country',
  nominalValue: 'Nominal value',
  weight: 'Weight',
  size: 'Size',
  nextSteps: 'Next steps',
  nextStep: 'Next step',
  andThen: 'And then',
  publish: 'Publish',
  saveDraft: 'Save draft',
  editSelectedReceptions: 'Edit selected receptions',
  editReception: 'Edit reception',
  editCase: 'Edit case',
  newCase: 'New case',
  upload: 'Upload',
  uploading: 'Uploading',
  personnelAssigned: 'Personnel assigned',
  status: 'Status',
  productStatus: 'Product Status',
  featuredImage: 'Featured image',
  required: 'Required!',
  adminNote: 'Admin note',
  name: 'Name',
  condition: 'Condition',
  conditionDescription: 'Condition description',
  quantity: 'Quantity',
  ruler: 'Ruler',
  olympia: 'Olympia',
  designer: 'Designer',
  manufacturer: 'Manufacturer',
  taxableStatus: 'Taxable status',
  webShopPrice: 'Webshop price',
  purchasedPrice: 'Purchased price',
  AuctionMinimumPrice: 'Auction minimum price',
  estimatedPrice: 'Estimated price',
  productCategory: 'Product category',
  editNewProduct: 'Edit New Product',
  editProducts: 'Edit Products',
  editSelectedProducts: 'Edit selected products',
  filter: 'Filter',
  inAuction: 'In auction',
  inWebshop: 'In webshop',
  notSold: 'Not sold',
  bulkEdit: 'Bulk Edit',
  image: 'image',
  date: 'Date',
  edit: 'Edit',
  assignToWoocommerce: 'Assign to woocommerce',
  assignToAuction: 'Assign to auction',
  putIntoStorage: 'Put into storage',
  holmastoWillBuyIt: 'Holmasto will buy it',
  holmastoWillSellIt: 'Holmasto will sell it on behalf of seller',
  returnToSeller: 'Return to seller',
  auction: 'Auction',
  addAuction: 'Add auction',
  auctionId: 'Auction Id',
  startDate: 'Start date',
  estimatedValue: 'Estimated value',
  categories: 'Categories',
  uncategorizedProduct: 'Products, Added to auction but not categorised',
  login: 'Login',
  forgotPassword: 'Forgot password',
  resetPassword: 'Reset password',
  notValidEmail: 'Should be a valid email!',
  backToLogin: 'Back to Login',
  createdAt: 'Created at',
  email: 'Email',
  users: 'Users',
  addUser: 'Add user',
  firstName: 'First name',
  lastName: 'Last name',
  postalCode: 'Postal code',
  admin: 'Admin',
  shippingContainer: 'Shipping container',
  small: 'Small',
  medium: 'Medium',
  large: 'Large',
  requiresSpecialHandling: 'Requires special handling',
  owner: 'Owner',
  proposedPrice: 'Proposed price',
  proposalText: 'Proposal text',
  city: 'City',
  state: 'State',
  additionalAddress: 'Additional address',
  areYouSure: 'Are you sure?',
  cancel: 'Cancel',
  delete: 'Delete',
  thisActionCanNotBeUndone: 'This action can not be undone!',
  warehouseId: 'warehouse ID',
  lengthShouldBe1: 'Length should Be 1',
  onlyCapitalAlphabeticChars: 'Only capital alphabetic character',
  active: 'Active',
  inactive: 'Inactive',
  sentForApproval: 'Send for approval',
  draft: 'Draft',
  rejected: 'Rejected',
  accepted: 'Accepted',
  pending: 'Pending',
  holmasto: 'Holmasto',
  customer: 'Customer',
  itemStatus: 'Item Status',
  noImage: 'NO IMAGE',
  noInformation: 'NO INFORMATION',
  createCategory: 'Create Category',
  editCategory: 'Edit Category',
  label: 'Label',
  categoryImage: 'Category Image',
  chooseImage: 'Choose Image',
  choose: 'Choose',
  category: 'Category',
  productsYoureEditing: "Products you're editing",
  productsWhereUpdated: 'Products where updated',
  changeFieldsToUpdate: 'Change fields to update',
  updateAll: 'Update All',
  auctionCategory: 'Auction Category',
  productCategories: 'Product Categories',
  sku: 'SKU',
  maxLengthIsThree: 'Field contain max 3 characters',
  editAuction: 'Edit Auction',
  generatePdf: 'Generate PDF',
  markAsComplete: 'Mark as Complete',
  experts: 'Experts',
  completed: 'Completed',
  incomplete: 'Incomplete',
  canBeSentByAssignedPersona: 'Proposal can be sent by Assigned user only',
  sendProposal: 'Send proposal',
  publishForPrebid: 'Publish for Prebid',
  editUser: 'Edit User',
  tags: 'Tags',
  tag: 'Tag',
  addTag: 'Add Tag',
  editTag: 'Edit Tag',
  from: 'From',
  to: 'To',
  images: 'Images',
  superAdmin: 'Super Admim',
  role: 'Role',
  client: 'Client',
  disable: 'Disable',
  enable: 'Enable',
  parent: 'Parent',
  newPasswordWasSentToUser: 'New password was sent to the user',
  changePassword: 'Change Password',
  profile: 'Profile',
  logOut: 'Log out',
  password: 'Password',
  confirmPassword: 'Confirm Password',
  passwordsDoesntMatch: "Passwords doesn't match",
  passwordWasUpdated: 'Password was updated',
  profileWasUpdated: 'Profile was updated',
  passwordShouldBemoreThen6Chars: 'Password should be more then 6 characters',
  wrongPassword: 'Wrong password',
  currentPassword: 'Current Password',
  mightBuyLabel: 'Includes products Holmasto might buy',
  soldOnBehalfLabel: 'Includes products sold on behalf of the customers',
  internalNote: 'Internal Note',
  startDatePreBid: 'Prebid Start',
  createTag: 'Create tag',
  endDatePreBid: 'Pre-Bid End Date',
  auctionIdShouldBeUnique: 'Auction id should be unique',
  more: 'More',
  less: 'Less',
  itemNumber: 'Item Number',
  dateTime: 'Datetime',
  user: 'User',
  userId: 'User Id',
  bid: 'Bid',

  bids: 'Bids',
  amount: 'Amount',
  addBid: 'Add Bid',
  minimumAmountIs: 'Minimum amount is',
  increase: 'Increase',
  timeToMakeAnOffer: 'Aikaa tehdä tarjous (en)',
  nSeconds: '{{ n }} sek (en)',
  timerLength: 'Tarjousajan pituus (en)',
  startAgain: 'ALOITA UUDESTAAN (en)',
  pause: 'PYSÄYTÄ (en)',
  resume: 'JATKA (en)',
  next: 'SEURAAVA (en)',
  liveAuctionHasEndedAt: 'Live auction has ended at {{ date }}',
  paletteNumber: 'Palette number',
  fieldShouldBeUnique: 'This field should be unique',
  liveAuction: 'Live auction',
  shouldBeInteger: 'This field should be integer',
  attachUserOnBid: 'Attach user on bid',
  complete: 'Complete',
  bidding: 'Bidding',
  bidder: 'Bidder',
  nextItem: 'Seuraava kohde',
  itemNumberNofT: 'Kohdenumero {{ n }} / {{ t }}',
  raise: 'RISE',
  minimumRise: 'Rise',
  minimumRiseN: 'Rise (minimum {{ n }} €)',
  closeCurrentItem: 'CLOSE CURRENT ITEM',
  autopilot: 'AUTOPILOT ON',
  manualMode: 'MANUAL',
  enableAutopilot: 'Enable autopilot',
  disableAutopilot: 'Stop autopilot',
  hammerDelay: 'Hammer delay',
  hammerDelayHelp:
    'How long autopilot waits after the bidding time ends before hammering the item. Late bids still count and restart the bidding time.',
  orders: 'Orders',
  items: 'Items',
  phoneNumber: 'Phone Number',
  bidCount: 'Bid count',
  myWork: 'My work',
  clients: 'Clients',
  holmastoId: 'Holmasto ID',
  verificationStatus: 'Verification Status',
  isVerified: 'Verified',
  editClientN: 'Edit client {{ holmastoId }}',
  userDocuments: 'User Documents',
  note: 'Note',
  notes: 'Notes',
  inWarehouse: 'In warehouse',
  auctionStatus: 'Auction status',
  maxBiddingLevel: 'Max bidding level',
  copyProduct: 'Copy Product',
  productWasSaved: 'Product was saved',
  productWasCreated: 'Product was created',
  publishOnline: 'Publish Online',
  markAsFeatured: 'Mark as featured',
  itemsCountN: 'Items count: {{ n }}',
  bidsCountN: 'Bids count: {{ n }}',
  auctionN: 'Auction {{ n }}',
  itemsSoldN: 'Sold items: {{ n }}',
  trendingItems: 'Trending Items',
  trendingCategories: 'Trending Categories',
  price: 'Price',
  unpublish: 'Unpublish',
  compensate: 'Compensate',
  undoCompensation: 'Undo Compensation',
  compensated: 'Compensated',
  yes: 'Yes',
  no: 'No',
  sum: 'Sum',
  commission: 'Commission',
  sellerReceives: 'Seller receives',
  sellerCommissions: 'Seller Commissions',
  sellerProducts: 'Seller products',
  startAmount: 'Start amount',
  soldAmount: 'Sold amount',
  sellerCommissionWasUpdated: 'Seller commission was updated',
  update: 'Update',
  auctionHasUnpublishedProducts: 'Auction has unpublished product, would you like to continue?',
  editSeller: 'Edit Seller',
  sellers: 'Sellers',
  accountNumber: 'Bank account number',
  accountNumberRequired: 'Bank account number is required for bank transfer payment',
  bankAccountWillBeReadFromCustomerDetails: 'Bank account will be read from customer details',
  countries: 'Countries',
  none: 'None',
  receptionWasSaved: 'Reception was saved',
  attachedCard: 'Attached Card',
  lastDigits: 'Last Digits',
  expirationDate: 'Expiration Date',
  verified: 'Is verified',
  isSeller: 'Is Seller',
  accountType: 'Account Type',
  personal: 'Personal',
  business: 'Business',
  businessId: 'Business ID',
  handlingOrganizationName: 'Handling organization name',
  contactPerson: 'Contact Person',
  shippingOrderStatus: 'Shipping order status',
  manageOrder: 'Manage order',
  manageShippingOrder: 'Manage shipping order',
  serialNumber: 'Serial Number',
  zipCode: 'Zip code',
  liveAuctionStarted: 'Live auction started',
  liveAuctionEnded: 'Live auction ended',
  shippingIsSameAsBilling: 'Shipping address is same as billing address',
  shippingAddress: 'Shipping Address',
  billingAddress: 'Billing Address',
  nationality: 'Nationality',
  bidLimitRequests: 'Bid Limit requests',
  disabled: 'Disabled',
  editBid: 'Edit bid',
  notifyWhenBidIsWinning: 'Notify when bid is winning',
  notifyWhenBidIsntWinning: "Notify when bid isn't winning",
  notifications: 'Notifications',
  wrongCredentials: 'Wrong Credentials',
  generateExcel: 'Generate Excel',
  alreadyCompensated: 'Already compensated',
  sellerGets: 'Seller gets',
  invoice: 'Invoice',
  approvedReceptions: 'Approved Receptions',

  passwordConfirmation: 'Password confirmation',
  passwordShouldBeMinimum: 'Password should be kinimum {{ minimum }}',
  passwordsMustMatch: 'Passwords must match',
  unknownError: 'Unknknown error',
  serverErrorTryAgain: 'Server error, please try again',
  confirmDeleteReception: "Do you really want to delete the reception? This action can't be undone",
  isWinning: 'Is winning',
  userName: 'User Name',
  lotNumber: 'Lot number',
  notVerified: 'Not verified',
  marginalRate: 'Marginal rate',
  vatPercent: 'Vat percent',
  openOrders: 'Open orders',
  createWebshopOrder: 'Create webshop order',
  sellerCommission: 'Seller Commission',
  buyerCommission: 'Buyer Commission',
  sellerFee: 'Seller Fee',
  generateSoldProductExcel: 'Generate sold product excel',
  system: 'System',
  online: 'Online',
  facilitator: 'Facilitator',
  wonItems: 'Won items',
  wonPrice: 'Won price',
  receptions: 'Receptions',
  soldProducts: 'Sold products',
  paidWith: 'Paid with',
  shipment: 'Shipment',
  total: 'Total',
  view: 'View',
  open: 'Open',
  closed: 'Closed',
  deadline: 'Deadline',
  openReceptionIAmPersonalAssigned: 'Open receptions where I am personnel assigned',
  pendingReceptionsAssignedToMe: 'Pending receptions',
  readyToSendReceptionsAssignedToMe: 'Receptions ready to send',
  sendReminder: 'Remind about evaluation',
  remind: 'Reminder',
  reminderWasSent: 'Reminder sent',
  openReceptionIAmExpert: 'Open receptions where I am expert',
  id: 'ID',
  daysBeforeDeadline: 'Days before deadline',
  openItemAcceptancesWhereIAmAssignedReception: 'Open item acceptances where I am personnel assigned in reception',
  openItemAcceptancesWhereIAmAssigned: 'Open item acceptances where I am personnel assigned',
  receptionId: 'Reception ID',
  receptionPersonell: 'Reception Personell',
  customerName: 'Customer name',
  sellerName: 'Seller name',
  bidsTotal: 'Bids total',
  uniqueCustomersWithBids: 'Unique customers with bids',
  itemsWithBids: 'Items with bids',
  sumOfWinningPreBids: 'Sum of winning pre bids',
  sumOfWinningLiveBids: 'Sum of winning live bids',
  soldItems: 'Sold items',
  categoriesWithMostBids: 'Categories with most bids',
  kpi: 'KPI',
  auctionTotals: 'Auction totals',
  openReceptions: 'Open receptions',
  openItems: 'Open items',
  newCustomers: 'New customers',
  purchaseInvoiceCreated: 'Purchase invoice created',
  requestedAt: 'Requested at',
  payments: 'Payments',
  totalSum: 'Total sum',
  completedOrders: 'Completed orders',
  shippingMethod: 'Shipping Method',
  buyerPays: 'Buyer pays',
  orderItems: 'Order items',
  acceptedReceptionProposals: 'Accepted reception proposals',
  notCompensated: 'Not compensated',
  numberOfItems: 'Number of items',
  paymentStatus: 'Payment status',
  compensationStatus: 'Compensation status',
  fee: 'Fee',
  sellerItems: 'Seller Items',
  sellerSoldItems: 'Seller sold items',
  compensatedWithoutPurchaseInvoice: 'Compensated without purchase invoice',
  compensateSeller: 'Compensate Seller',
  createPurchaseInvoices: 'Create purchase invoice for selected',
  markPaidInStore: 'Mark paid in store',
  language: 'Language',
  generateContract: 'Generate contract',
  verificationMethod: 'Verification method',
  basic_info_filled: 'Basic info filled',
  copyProductToNewAuction: 'Copy product to new auction',
  copyToAuction: 'Copy to auction',
  totalCommission: 'Total Commission',
  boughtBy: 'Bought by',
  buyerUnknown: 'Buyer unknown',
  itemAcceptance: 'Item acceptance',
  unsavedChangesPrompt: 'There are some unsaved changes',
  clientWasUpdated: 'Client was updated',
  clientWasCreated: 'Client was created',
  categoryWasUpdated: 'Category was updated',
  categoryWasCreated: 'Category was created',
  tagWasUpdated: 'Tag was updated',
  tagWasCreated: 'Tag was created',
  receptionWasUpdated: 'Reception was updated',
  receptionWasCreated: 'Reception was created',
  timerIsStillActive: 'Timer is still active',
  onlineCustomers: 'Online Customers',
  otherCustomers: 'Other Customers',
  evaluation: 'Evaluation',
  toSell: 'To sell',
  estateInventory: 'Estate inventory',
  insuranceEvaluation: 'Insurance evaluation',
  gemmologicalExamination: 'Gemmological examination',
  purposeOfSale: 'Purpose of case',
  toAuction: 'To auction',
  salesOrder: 'Sales order',
  notifySeller: 'Notify seller',
  oneTimeCustomers: 'One Time customers',
  paidInStore: 'Paid in store',
  before: 'Before',
  after: 'After',
  verifyUsers: 'Verify users',
  internalError: 'Internal Error',
  proposal: 'Proposal',
  proposalPdf: 'Proposal PDF',
  printTheReceptionReceipt: 'Print reception receipt',
  enableEdit: 'Enable',
  disableEdit: 'Ota pois käytöstä (en)',
  approved: 'Approved',
  created: 'Created',
  readyToSend: 'Ready to send',
  published: 'Published',
  declined: 'Rejected',
  auctionCountdown:
    'Auction should start in {{ m }} months, {{ d }} days, {{ h }} hours , {{ mi }} minutes and {{ s }} seconds',
  notifyUsersToPay: 'Notify users to pay',
  sentWaitingForAnswer: 'Sent, waiting for answer',
  liveAuctionWillStartIn: 'Live auction will start in',
  other: 'Other',
  pendingEmails: 'Login email verifications',
  resendEmail: 'Resend Email',
  yourRequestHasCompleted: 'Your request has been completed',
  userWasAlreadyNotifiedNotifyAgain: 'Email was already send. Do you want to send again?',
  companyName: 'Company name',
  company: 'Company name',
  proposalSent: 'Proposal sent',
  tools: 'Tools',
  management: 'Management',
  notifiSellerReceptionReceived: 'Send email: We have received your items for evaluation',
  printTheQrCode: 'Print QR code',
  qrCodeError: 'QR code cannot be generated: product ID is missing',
  directPurchase: 'Direct purchase',
  notifyReceptionEvaluationHasCompleted: 'Send email: The evaluation is completed!',
  printSalesReceipt: 'Print sales contract',
  createPurchaseInvoice: 'Create purchase invoice',
  purchaseInvoiceWasCreated: 'Purchase invoice was created',
  sendSalesContract: 'Send email: Sales contract',
  printSalesContract: 'Print sales contract',
  notificationWasSent: 'Notification was sent',
  startLiveAuction: 'Start live auction',
  auctionHasNoProducts: 'Please add products to auction before you start live auction',
  unPublished: 'Un-published',
  saveChanges: 'Save changes',
  fastTrackReceptions: 'Fast track deals',
  addFastTrackReception: 'Add deal',
  socialSecurityNumber: 'Date of birth or/+ PIN',
  paymentMethod: 'Payment Method',
  noData: "You haven't added items yet",
  taxClass: 'Tax class',
  fastBuyItems: 'Merchandise information',
  updateFastTrackReception: 'Update fast deal',
  markAsCompensated: 'Mark as compensated in store',
  address: 'Address',
  streetAddress: 'Street address',
  phone: 'Phone',
  phoneNumberAlreadyExists: 'Phone number already exists',
  emailAlreadyExists: 'Email already exists',
  fastTrackReceptionWasUpdated: 'Fast track deal was updated',
  fastTrackReceptionWasCreated: 'Fast track deal was created',
  add: 'Add',
  history: 'History',
  cash: 'Cash',
  bankTransfer: 'Bank transfer',
  netvisor: 'Netvisor',
  productCantBePublished: "Productb {{ sku }} can't be published",
  setStatus: 'Update the status of selected products',
  accountNumberIsRequired: 'In order to create purchase invoice fill account number',
  addRow: 'Add row',
  addItem: 'Add item',
  receipts: 'Receipts',
  form: 'Form',
  createSalesContract: 'Create sales contract',
  runningNumber: 'Running number',
  productWasUnsold: 'Product was unsold',
  sellToUser: 'Sell to user',
  youReAboutToChangeAssignedAuctionId: "You're about to change assigned auction",
  youCantChangeSoldProductsAuction: "You can't change assigned auction for sold product",
  addBillingAddress: 'Add billing address',
  itemWasSoldToTheUser: 'Items as sold to user',
  printActions: 'Print actions',
  editProduct: 'Edit product',
  unlockForEditing: 'Unlock for editing',
  lockForEditing: 'Lock for editing',
  afterAuctionTools: 'After auction tools',
  unsell: 'Unsell',
  purchaseItemToHolmasto: 'Purchase item to holmasto',
  moveToAnotherAuction: 'Move to another auction',
  previewProductInCatalogue: 'Preview auction in catalogue',
  returnedToSeller: 'Returned to seller',
  sold: 'Sold',
  current: 'Current',
  waiting: 'Waiting',
  biddingEnded: 'Bidding ended',
  readyForCatalogue: 'Ready for catalogue',
  actions: 'Actions',
  soldToHolmasto: 'Sold to holmasto',
  movedFromEarlierAuction: 'Moved from earlier auction',
  itemCreated: 'Created',
  updated: 'Updated',
  grouped: 'Grouped',
  list: 'List',
  type: 'Type',
  verfictionStatus: 'Verification status',
  disableFromCatalogue: 'Disable from catalogue',
  enableInCatalogue: 'Enable in catalogue',
  featuredImages: 'Featured Images',
  startPrice: 'Start price',
  filterItemDescription: 'Filter item description',
  copy: 'Copy',
  historyItems: 'History items',
  itemWasCompied: 'Item was copied',
  createWebshopProduct: 'Create webshop product',
  webshopProduct: 'Webshop product',
  editWebshopProduct: 'Edit webshop product ({{ lang }})',
  showFullTable: 'Show full table',
  tempId: 'Temporary id',
  archived: 'Archived',
  archive: 'Archive',
  archiveLabel: 'Archive',
  archiveReception: 'Archive',
  unarchive: 'Unarchive',
  proposalWasSent: 'Sales contract was sent',
  holmastoItems: 'Holmasto items',
  customerItems: 'Customer items',
  allItems: 'All items',
  customerDistribution: 'Customer distribution',
  notSoldItems: 'Not sold items',
  avgPrice: 'Avg price',
  startingAvgPrice: 'Starting avg price',
  holmastoSalesTotal: 'Holmasto sales total',
  buyerCommissionTotal: 'Buyer commission total',
  sellerPayoutTotal: 'Seller payout total',
  collapseAll: 'Collapse all',
  expandAll: 'Expand all',
  checkingSyncStatus: 'Checking sync status...',
  errorCheckingSyncStatus: 'Error checking sync status',
  productsInSync: 'Products are in sync',
  productsOutOfSync: 'Products are out of sync',
  missingProducts: '{{count}} product(s) missing from auction',
  extraProducts: '{{count}} extra product(s) in auction',
  outdatedProducts: '{{count}} product(s) need updating',
  syncNow: 'Sync Products',
  syncing: 'Syncing...',
  syncCompleted: 'Sync completed: {{added}} added, {{updated}} updated, {{removed}} removed',
  syncFailed: 'Sync failed',
  lotNumbersLockedSyncNote:
    'Note: Lot numbers are locked (catalog published or prebidding started) - only existing products will be updated. No products will be added or removed (lot numbers preserved). Category hierarchies will be recalculated.',
  generatePreviewCatalogue: 'Generate Preview Catalogue (Private)',
  generatePublicCatalogue: 'Generate Public Catalogue',
  generatePublicCatalogueWithHammerPrice: 'Generate Public Catalogue with Hammer Price',
  productsOutOfSyncConfirmPublish:
    'Products are out of sync! Publishing now may show incorrect data to customers. Do you want to publish anyway?\n\nRecommended: Click Cancel, then click "Sync Now" button above products, then publish.',
  viewOutOfSyncDetails: 'View out-of-sync product details',
  reason: 'Reason',
  'syncReason.missing': 'Missing from auction',
  'syncReason.extra': 'Extra in auction',
  'syncReason.outdated': 'Outdated',
  'syncReason.fields': 'Fields outdated',
  'syncReason.categories': 'Categories outdated',
  'syncReason.fields, categories': 'Fields & categories outdated',
  nonPublishedAssignedProducts: '{{count}} assigned product(s) not yet published',
  nonPublishedAssignedProductsNote:
    'These products are assigned to this auction but have not been published yet. They will appear in the auction subcollection once their status is changed to "published" (Ready for catalogue).',
  viewNonPublishedProducts: 'View non-published products',
  searchClients: 'Search customers',
  noClientsFound: 'No customers found',
  clientDetails: 'Client details',
  accountType_personal: 'Private customer',
  accountType_business: 'Business customer',
  accountTypeMissing: 'Account type missing',
  valueMissing: '{{ valueName }} missing',
  createNewReception: 'Create new reception',
  itemLocation: 'Item location',
  customerPicksUpNonValuable: 'Customer picks up non-valuable items',
  listingPrice: 'Listing price',
  customerSharePercent: 'Customer share percent',
  customerShareAmount: 'Customer share amount',
  pleaseFixErrorsAndTryAgain: 'Please fix errors and try again',
  salesExpenses: 'Sales expenses',
  expertServices: 'Expert services',
  gemmologist: 'Gemmologist',
  goldsmith: 'Goldsmith',
  certificate: 'Certificate',
  otherExpert: 'Other expert',
  done: 'Done',
  notDone: 'Not done',
  eventHistory: 'Event history',
  noChangelogFound: 'No changelog found',
  noReceptionsFound: 'No receptions found',
  noNotesFound: 'No notes found',
  expertServiceDetails: 'Expert service details',
  serviceType: 'Service type',
  intake: 'Intake',
  selectReceptionCategory: 'Select case category',
  personalIdOrBirthdate: 'Personal ID or birthdate',
  intakeCategoryDescription: 'To sell, to auction or sales order',
  expertCategoryDescription: 'Expert services for reception',
  fastTrackCategoryDescription: '',
  selectExpertServiceTypeToBegin: 'Select expert service',
  createNewCase: 'Create new case',
  currentData: 'Current data',
  profileMissingRequiredFields: 'Customer profile is missing required information:',
  addNewNote: 'Add new note',
  close: 'Close',
  erasurePreviewIntro:
    'These records may belong to the same person. The client to erase and records of the same person are selected; review the rest and select the ones to erase.',
  erasureConfidence_requested: 'Client to erase',
  erasureConfidence_likely: 'Probably the same person',
  erasureConfidence_possible: 'Possibly the same person',
  erasureMatchedBy: 'Found by',
  erasureMatch_personalId: 'Personal identity code',
  erasureMatch_email: 'Email',
  erasureMatch_authEmail: 'Login email',
  erasureMatch_phone: 'Phone',
  erasureViaCandidate: 'via another record',
  erasureDiffers: 'Differs',
  erasureActivity_bids: 'Bids',
  erasureActivity_orders: 'Orders',
  erasureActivity_receptions: 'Receptions',
  erasureActivity_fastTrackReceptions: 'Fast track receptions',
  erasureActivity_sellerCommissions: 'Seller commissions',
  erasureKind_fastTrackReception: 'Legacy fast track reception without a profile',
  erasureColumn_record: 'Record',
  erasureColumn_contact: 'Contact details',
  erasureColumn_comparison: 'Compared with the request',
  erasureColumn_status: 'Activity and status',
  erasureRequestedProfile: 'Other records are compared with this one',
  erasureBlocked: 'Erasure is not possible until these are resolved',
  erasureBlocker_bidInOpenAuction: 'Bid in an auction that has not ended',
  erasureBlocker_uncompensatedFastTrackReception: 'Uncompensated fast track reception',
  erasureBlocker_uncompensatedSellerCommission: 'Uncompensated seller commission',
  erasureBlocker_staffAccount: 'Staff account, not erased here',
  erasureRetention: 'Kept until {{date}}',
  erasureRetention_seller: 'Seller',
  erasureRetention_buyer: 'Buyer',
  erasureRetainedInfo:
    'Identification details of {{count}} selected records are kept for six years from the end of the year of their last purchase or sale. Everything else is erased.',
  erasureSelected: '{{count}} records selected.',
  erasureWarning_openReception: 'Unfinished reception',
  erasureWarning_unpaidOrder: 'Unpaid order',
  erasureCheckBefore: 'Check before erasing',
  erasureConfidence_certain: 'Same person',
  erasureMatch_accountNumber: 'Account number',
  erasureMatch_surnameAndBirthDate: 'Surname and birth date',
  erasureMatch_nameAndPostalCode: 'Name and postal code',
  erasureConflicts: 'Conflict',
  erasureConflict_personalId: 'Different personal identity code',
  erasureConflict_name: 'Different name',
  erasureBirthDate: 'Birth date',
  erasurePersonalId: 'Personal identity code',
  erasureAccountNumber: 'Account number',
  erasureComparison_same: 'same',
  erasureComparison_different: 'different',
  erasureWarning_thirdPartyName: "The name field may hold another person's details",
  back: 'Back',
  erasureOpen: "Erase client's data",
  erasureTitle: "Erase client's data",
  erasureNoOthersFound:
    'No other client records that might belong to the same person were found. The search used the personal identity code, email, phone number, account number and name.',
  erasureStep_select: 'Client records',
  erasureStep_verify: 'Request and identification',
  erasureStep_summary: 'Review and erase',
  erasureStep_done: "Client's data erased",
  erasureContinue: 'Continue',
  erasureShowSummary: 'Show what will be erased',
  erasureErase: 'Erase permanently',
  erasureConfirm: 'Erase the data of {{count}} records permanently? This cannot be undone.',
  erasureDone: 'The data has been erased and the erasure logged. Do the manual steps below.',
  erasureSummaryIntro: 'Nothing has been erased yet.',
  erasureErrorBlocked: 'Erasure is blocked: one of the selected records has changed. Open the erasure again.',
  erasureErrorWarnings: 'Acknowledge the warnings before erasing.',
  erasureErrorInvalid:
    'Check the details: the selection or the form is not valid. Open the erasure again if the records have changed.',
  erasureRequestReceivedAt: 'Request received',
  erasureRequestReceivedAtHelp: 'The reply is due within a month of this day.',
  erasureNoPersonalData: 'Do not enter identity codes or document numbers: the fields go to the erasure log.',
  erasureVerificationMethod: 'How was the identity verified?',
  erasureMethod_emailRequest: 'The request came from the registered email address',
  erasureMethod_sms: 'SMS code to the registered phone number',
  erasureMethod_email: 'Confirmation from the registered email address',
  erasureMethod_emailHelp: 'A separate message to the registered address that the customer answered',
  erasureMethod_inPerson: 'Identity document checked in person',
  erasureMethod_other: 'Other method',
  erasureMethod_otherDescription: 'Describe the method',
  erasureReferenceHelp: 'E.g. the email subject or a ticket number.',
  erasureVerifiedAt: 'Verified on',
  erasureReference: 'Where the request is',
  erasureWarningsAcknowledged: 'I have checked these before erasing:',
  erasureAcknowledge_openReception: 'open receptions have been handled and the items returned',
  erasureAcknowledge_unpaidOrder: 'unpaid orders will no longer be collected',
  erasureAcknowledge_thirdPartyName: 'other people’s details in the name fields have been resolved',
  erasureWillDelete: 'Will be deleted',
  erasureDeleted: 'Deleted',
  erasureWillClear: 'Personal data will be cleared',
  erasureCleared: 'Personal data cleared',
  erasureKeptUntil: 'Identification data is kept until {{date}}.',
  erasureKeptDocuments: 'Identity documents kept: {{count}}.',
  erasureNothingKept: 'Nothing is kept.',
  erasureKeptWithoutDetails: "Kept without the client's details",
  erasureKept_bids: 'bids',
  erasureKept_orders: 'orders',
  erasureCopy: 'Copy',
  erasureCopied: 'Copied',
  erasureManualSteps: 'After erasing, do by hand',
  erasureManual_woocommerce: 'WooCommerce: open the WordPress personal data eraser and do this for each email below',
  erasureManual_woocommerceStep_paste: 'Copy the email into "Username or email address"',
  erasureManual_woocommerceStep_noConfirmation:
    'Untick "Send personal data erasure confirmation email.": the identity is already verified. With it ticked WordPress waits for the customer to confirm and erases nothing.',
  erasureManual_woocommerceStep_erase: 'Press "Send Request", then "Erase personal data" on the request row',
  erasureManual_noEmail: 'The selected records have no email',
  erasureManual_reply: 'Reply to the customer: what was erased and what is kept',
  erasureManual_thirdParty:
    "A name field holds another person's details: handle it separately, the request covers only the requester's own data",
  erasureCount_authUser: 'MyHolmasto login',
  erasureCount_profile: 'client profile',
  erasureCount_profileSubcollections: 'notes, card verification details and wishlist',
  erasureCount_storageFiles: 'uploaded files',
  erasureCount_changelogsDeleted: "the client's change log",
  erasureCount_rateLimits: 'login attempt counters',
  erasureCount_products: 'products',
  erasureCount_receptions: 'receptions',
  erasureCount_receptionExperts: 'reception expert copies',
  erasureCount_paletteUsers: 'palette numbers',
  erasureCount_sellerCommissions: 'seller commissions',
  erasureCount_fastTrackReceptions: 'fast track receptions',
  erasureCount_changelogsScrubbed: 'changelogs of other records',
})

export default en
